import Image from 'next/image'
import cn from 'classnames'
import rootStyles from '../../pages/puppy/[id].module.scss'
import s from './Why.module.scss'
import Title from '../Title'
import TextBody from '../TextBody/TextBody'

const whyCards = [
  {
    icon: '/badge-on.svg',
    title: 'Responsible Breeders',
    alt: 'Mawoo caring breeder certificate'
  },
  {
    icon: '/icons/health.svg',
    title: 'Health Guarantee',
    alt: 'Green search icon with a heart in the middle'
  },
  {
    icon: '/concierge-on.svg',
    title: 'Excellent Customer Service',
    alt: 'Concierge boy with heart icon on his vest'
  },
  {
    icon: '/icons/secure.svg',
    title: 'Secure and Simple Process',
    alt: 'lock and a shield icon'
  },
  {
    icon: '/travel-on.svg',
    title: 'Pickup & Delivery',
    alt: "Smiling girl with a dog sitting to her right and a heart icon above the dog's head"
  }
]

export default function Why () {
  return (
    <section className={cn(rootStyles.section, s.why)}>
      <div className={s.why_titles}>
        <Title variant='h2'> Why Mawoo Pets? </Title>

        <TextBody>
          We pride ourselves on bringing healthy puppies from trusted breeders
          to loving forever homes.
        </TextBody>
      </div>

      <div className={s.why_cards}>
        {whyCards.map((card, index) => (
          <div key={index} className={s.why_cards_item}>
            <Image
              width={65}
              height={65}
              src={card.icon}
              alt={card.alt}
              className={s.why_cards_item_icon}
            />

            <div className={s.why_cards_item_text}>
              <TextBody size='s' weight='bold'>
                {card.title}
              </TextBody>
            </div>
          </div>
        ))}
      </div>

      <div className={s.why_trustpilot}>
        <a
          className={s.why_trustpilot_rating}
          aria-label='Read more about trustpilot'
          href='https://www.trustpilot.com/review/www.mawoopets.com?utm_medium=trustbox&utm_source=Carousel'
        >
          <h2>Excellent</h2>
          <img
            src='/truspilot/five-starts-truspilot.svg'
            className={s.why_trustpilot_star}
            aria-label='Stars Trustpilot'
          />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>
              <b>4.8</b> out of 5 on
            </span>
            <img
              src='/truspilot/logo.svg'
              className={s.why_trustpilot_logo}
              aria-label='Brand Trustpilot'
            />
          </div>
        </a>
      </div>
    </section>
  )
}
